

















































































































import { Search, SortDirection } from '@/data/models/search.model';
import { ServiceInstance } from '@/data/models/serviceinstance.model';
import { CrudService } from '@/data/services/crud.service';
import { Component, Inject, Vue } from 'vue-property-decorator';

@Component
export default class CalendarioServiziList extends Vue {

	@Inject('CrudService') crudService!: CrudService<ServiceInstance>;

	rows: ServiceInstance[] = [];
	loading: boolean = false;

	advancedSearch: Search = new Search('serviceinstance');
	selectedServices: ServiceInstance[] = [];

	constructor() {
		super();
		this.advancedSearch.setSortDirection(SortDirection.ASCENDING);
		this.advancedSearch.setSortField('startdate');
	}

	loadServices() {
		const datareq = this.crudService.searchEntities(
			ServiceInstance,
			'serviceinstance',
			this.advancedSearch,
			this.advancedSearch.page
		);
		const countreq = this.crudService.countEntities(
			ServiceInstance,
			'serviceinstance',
			this.advancedSearch
		);
		this.loading = true;
		Promise.all([datareq, countreq])
			.then((results) => {
				this.rows = results[0];
				this.advancedSearch.page.setTotal(results[1].ct);
			})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			})
			.finally(() => (this.loading = false));
	}

	deleteCampagna(item: ServiceInstance) {
		this.$emit('delete', item);
	}

	onPageChange(page: number) {
		this.advancedSearch.page.setPageNumber(page - 1);
		this.loadServices();
	}

	onSortChange(field: string, dir: string) {
		this.advancedSearch.setSortField(field);
		this.advancedSearch.setSortDirection(dir);
		this.loadServices();
	}

	getRowClass(row: ServiceInstance) {
		if(row.isCompleted) return 'has-background-success-light';
		if(row.isCanceled) return 'has-background-danger-light';
	}

	isCheckable(row: ServiceInstance) {
		return row.isBooked;
	}

	onCheck(checked: ServiceInstance[]) {
		this.$emit('update:selected', checked);
	}

	deleteServizio(item: ServiceInstance) {
		this.$buefy.dialog.confirm({
			message: this.$t('warning-servizio-delete') as string,
			type: 'is-danger',
			hasIcon: true,
			cancelText: this.$t('annulla') as string,
			onConfirm: () => {
				this.crudService
					.deleteEntity(ServiceInstance, 'serviceinstance', item)
					.then(() => {
						this.loadServices();
					})
					.catch((error) => {
						this.$buefy.notification.open({
							message: error.msg,
							type: 'is-danger',
						});
					});
			},
		});
	}
	
}

